/* =========================================================
   EGODRIFT Cart Discount
   Version: 1.0.1 — 2026-07-19
   Last change: add missing version header (audit item 5)
========================================================= */
(() => {
  // EGODRIFT cart accordions (v1.2.0 — 2026-07-13): details[data-ego-cart-accordion]
  // render open (no-JS-safe). Defaults: cart DRAWER (ancestor <cart-drawer>) —
  // collapsed on ALL viewports, the drawer stays lean; cart PAGE — collapsed on
  // mobile, expanded on desktop. Content guard everywhere: an applied discount
  // (data-has-content) or non-empty note textarea keeps its accordion open —
  // never hide what a customer already entered.
  function applyCartAccordionDefaults() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    document.querySelectorAll('details[data-ego-cart-accordion]').forEach(details => {
      const textarea = details.querySelector('textarea');
      const hasContent =
        details.hasAttribute('data-has-content') ||
        (textarea && textarea.value.trim().length > 0);
      const inDrawer = details.closest('cart-drawer') !== null;

      if (hasContent) {
        details.setAttribute('open', '');
      } else if (inDrawer || isMobile) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    });
  }

  window.addEventListener('DOMContentLoaded', applyCartAccordionDefaults);

  // Cart section re-renders (quantity changes on /cart, drawer refresh after
  // add-to-cart) replace the markup with the server-rendered open state;
  // re-apply the viewport default afterwards.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(applyCartAccordionDefaults, 0);
    });
  }

  function reopenCartDrawerAfterReload() {
    sessionStorage.setItem('egoOpenCartDrawer', 'true');
  }

  window.addEventListener('DOMContentLoaded', () => {
    if (sessionStorage.getItem('egoOpenCartDrawer') !== 'true') return;

    sessionStorage.removeItem('egoOpenCartDrawer');

    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  });

  document.addEventListener('submit', event => {
    const form = event.target;

    if (!form.matches('[data-ego-cart-discount-form]')) return;

    event.preventDefault();

    const input = form.querySelector('[data-ego-cart-discount-input]');
    const message = form.querySelector('[data-ego-cart-discount-message]');

    if (!input) return;

    const code = input.value.trim();

    if (!code.length) {
      if (message) message.textContent = 'Please enter a discount code.';
      return;
    }

    if (message) message.textContent = 'Applying discount code...';

    reopenCartDrawerAfterReload();

    const redirectUrl = window.location.pathname + window.location.search;

    window.location.href =
      `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectUrl)}`;
  });

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ego-cart-discount-remove]');

    if (!button) return;

    button.disabled = true;
    button.textContent = 'Removing...';

    reopenCartDrawerAfterReload();

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        discount: ''
      })
    })
      .then(response => {
        if (!response.ok) throw new Error('Discount could not be removed.');
        window.location.reload();
      })
      .catch(() => {
        sessionStorage.removeItem('egoOpenCartDrawer');
        button.disabled = false;
        button.textContent = 'Remove discount';
      });
  });
})();